var storefrontApp = angular.module('storefrontApp');
storefrontApp.controller('collectionController', ['$scope', 'inspirationService', 'urlService', 'randomService', 'loaderService', "modalService", "elasticService", "$window",
    function ($scope, inspirationService, urlService, randomService, loaderService, modalService, elasticService, $window) {
        $scope.shoppingGalleryImageUrl = window.__env.shoppingGalleryImageUrl;
        $scope.playVdo = false;
        $scope.getCollectionsByCategoryId = function (categoryId) {
            inspirationService.getcollectionsbycategoryid(categoryId).then(
                function (response) {
                    if (response && response.data) {
                        $scope.mainCollection = response.data[0];
                        $scope.collections = randomService.getRandomItemsfromListArray(
                            response.data, 12
                        );                        
                         getCollectionItemsByCollectionId($scope.mainCollection.id);
                    }
                }
            );
        }

        $scope.getCurrentCategory = function () {
            var categoryId = Number($window.currentCategoryId);
            inspirationService.getCategoryById(categoryId).then(
                function (response) {
                    if (response && response.data) {
                        $scope.currentCategory = response.data;
                        $scope.currentCategory.isNewCollection=inspirationService.isNewCollection($scope.currentCategory.createdDate);                       
                        $scope.getCollectionsByCategoryId(categoryId);
                    }
                }
            );
        }

        $scope.getCurrentCategory();

        //#region Helper Functions

        $scope.getCollectionById = function (id) {
            if ($scope.collections && $scope.collections.length > 0) {
                var result = $scope.collections.filter(function (collection) {
                    return collection.id == id;
                });

                if (result && result.length > 0) {
                    return result[0];
                }
                else {
                    return null;
                }
            }
        }

        $scope.getProjectImageUrl = function (name) {
            return urlService.getImageUrl(
                {
                    "definitionName": "project_tutorial",
                    "imgName": name
                }
            );
        }

        $scope.getAuthorProjectsUrl = function (authorId, authorName) {
            return urlService.getAuthorProjectsUrl(authorId, authorName);
        }

        //#endregion

        $scope.toggleKey = function (key, state) {
            $scope[key] = ((state == "true" || state == true) ? true : false);
        }

        $scope.onCollectionClick = function (collection, index) {
            loaderService.show();
            $scope.toggleKey("playVdo");
            $scope.modalCollection = collection;
            modalService.open("collection-modal");

            $scope.getCollectionById(collection.id);
            if (index > 0) {
                $scope.prevCollection = $scope.collections[index - 1];
                $scope.prevCollection.index = index - 1;
            }
            else {
                $scope.prevCollection = null;
            }

            if (index < $scope.collections.length - 1) {
                $scope.nextCollection = $scope.collections[index + 1];
                $scope.nextCollection.index = index + 1;
            }
            else {
                $scope.nextCollection = null;
            }

            getCollectionItemsByCollectionId($scope.modalCollection.id, true);

            loaderService.hide();
        }

        $scope.closeCollectionModal = function () {
            modalService.close("collection-modal");
        }

        function getProjectInfo() {
            var currentProjects = [];
            if ($scope.currentProjectIds && $scope.currentProjectIds.length > 0) {
                $scope.currentProjectIds.forEach(function (id) {
                    inspirationService.getProjectById(id).then(
                        function (response) {
                            if (response && response.data) {
                                var currentProject = response.data;
                                currentProject.imgUrl = $scope.getProjectImageUrl(response.data.imageFileName);
                                currentProject.authorName = response.data.authorFirstName + ' ' + response.data.authorLastName;
                                currentProjects.push(currentProject);
                            }
                        }
                    );
                });
            }
            $scope.currentProjects = currentProjects;
        }

        function getProductInfo() {
            $scope.currentProducts = [];
            if (angular.isDefined($scope.currentProductIds) && $scope.currentProductIds.length > 0) {
                elasticService.getElasticData(elasticService.buildFavoriteItemsInfoRequest(
                    $scope.currentProductIds.join('","').toLowerCase(),
                    $scope.currentProductIds.length
                )).then(
                    function (response) {
                        if (response && response.data) {
                            if (response.data.aggregations && response.data.aggregations.favorites) {
                                $scope.currentProducts = response.data.aggregations.favorites.hits.hits;
                            }
                        }
                    }
                );
            }
        }

        function getCollectionItemsByCollectionId(collectionId, state) {
            inspirationService.getCollectionItemsByCollectionId(collectionId).then(
                function (response) {
                    if (response && response.data) {
                        if (state) {
                            $scope.currentCollectionProducts = response.data;
                            $scope.currentProjectIds = [];
                            $scope.currentProductIds = [];
                            if ($scope.currentCollectionProducts && $scope.currentCollectionProducts.length > 0) {
                                $scope.currentCollectionProducts.forEach(
                                    function (product) {
                                        if (product.fK_ProjectId > 0) {
                                            $scope.currentProjectIds.push(product.fK_ProjectId);
                                        }
                                        else {
                                            $scope.currentProductIds.push(product.itemId);
                                        }
                                    }
                                );
                            }

                            getProjectInfo();
                            getProductInfo();
                        }
                        else {
                            $scope.productsUsed = response.data;
                            $scope.mainCollection.itemCount = response.data.length;
                        }
                    }
                }
            );
        }
     
    }
]);
